import { graphql } from 'gql';

export const gqlCreateRatioRow = graphql(`
    mutation uerCreateRatioRow($input: PriceListRatioRowCreateInput!) {
        uerCreateRatioRow(input: $input) {
            data {
                id
            }
            message
            result
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const gqlPriceListUerForConstraintRatio = graphql(`
    query uerPriceListUerForConstraintRatio(
        $skip: Int
        $take: Int
        $contractId: Long!
        $where: PriceListUerRowBaseFilterInput
        $order: [PriceListUerRowBaseSortInput!]
    ) {
        uerPriceListUerForConstraintRatio(
            skip: $skip
            take: $take
            contractId: $contractId
            where: $where
            order: $order
        ) {
            totalCount
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                chapter
                code
                groupCode
                groupId
                groupName
                id
                justification
                linkStatus
                name
                sectionId
                sectionName
                status
                uerClassifier
                unit
                sectionIsArtificial
            }
        }
    }
`);

export const priceListRatioRowGql = graphql(`
    query uerPriceListRatioRow($ratioRowId: Long!) {
        uerPriceListRatioRow(ratioRowId: $ratioRowId) {
            data {
                appliesTo {
                    appliesToCode
                    appliesToCodeName
                    uerPriceListGroupCode
                    uerPriceListGroupId
                    uerPriceListGroupName
                    uerPriceListSectionId
                    uerPriceListSectionName
                    appliesToId
                    isUsedLink
                }
                code
                groupId
                groupName
                id
                isIncludedInAct
                isIncludedInWorkOrder
                justification
                kem
                kmat
                knr
                kozp
                ksp
                ktz
                ktzzpm
                ratioType
                status
                workConditions
                isCustom
                groupIsArtificial
                groupType
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const updateRatioRowGql = graphql(`
    mutation uerUpdateRatioRow($input: PriceListRatioRowUpdateInput!) {
        uerUpdateRatioRow(input: $input) {
            data {
                appliesTo {
                    appliesToCode
                    appliesToCodeName
                    uerPriceListGroupCode
                    uerPriceListGroupId
                    uerPriceListGroupName
                    uerPriceListSectionId
                    uerPriceListSectionName
                    appliesToId
                    isUsedLink
                }
                code
                groupId
                groupName
                id
                isIncludedInAct
                isIncludedInWorkOrder
                justification
                kem
                kmat
                knr
                kozp
                ksp
                ktz
                ktzzpm
                ratioType
                status
                workConditions
                isCustom
                groupIsArtificial
                groupType
            }
            message
            result
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const updateRatioToWorkOrderFromPriceListGql = graphql(`
    mutation uerUpdateRatioToWorkOrderFromPriceList($input: PriceListRatioRowUpdateInput!, $workOrderPriceId: Long!) {
        uerUpdateRatioToWorkOrderFromPriceList(input: $input, workOrderPriceId: $workOrderPriceId) {
            id
            message
            result
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerPriceListUerSectionForConstraintRatioGql = graphql(`
    query uerPriceListUerSectionForConstraintRatio($contractId: Long!) {
        uerPriceListUerSectionForConstraintRatio(contractId: $contractId) {
            items {
                id
                name
                isArtificial
            }
        }
    }
`);

export const uerPriceListUerForDismantlingRatioGql = graphql(`
    query uerPriceListUerForDismantlingRatio(
        $contractId: Long!
        $groupType: DismantlingCoefficientTypeEnum
        $order: [PriceListUerDismantlingRatioDataSortInput!]
        $skip: Int
        $take: Int
        $where: PriceListUerDismantlingRatioDataFilterInput
    ) {
        uerPriceListUerForDismantlingRatio(
            contractId: $contractId
            groupType: $groupType
            order: $order
            skip: $skip
            take: $take
            where: $where
        ) {
            items {
                ratioCode
                uerCode
                uerGroupCode
                uerGroupName
                uerName
                unit
                uerId
                clientId
                isPreselected
                isRatio
                isUerBaseRow
                ratioCode
                ratioId
                uerCode
                uerGroupCode
                uerGroupName
                uerId
                uerName
                unit
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerRatioRowDefaultsGql = graphql(`
    query uerRatioRowDefaults($contractId: Long!, $ratioType: RatioTypeEnum!, $uerBaseRowId: Long) {
        uerRatioRowDefaults(contractId: $contractId, ratioType: $ratioType, uerBaseRowId: $uerBaseRowId) {
            result
            data {
                ratioType
                groupType
                groupId
                groupName
                subGroupId
                subGroupName
            }
        }
    }
`);
